<div class="badge-container" [ngClass]="{'with-text': text}">
  <span *ngIf="text" >{{text}}</span>
  <mat-icon *ngIf="icon" svgIcon="{{icon}}">

  </mat-icon>
</div>
